document.addEventListener('codeblackbelt:frequently-bought-together:rendered', function(event) {
		let checkboxes = document.querySelectorAll(".cbb-frequently-bought-selector-input");
		checkboxes.forEach( (item) => {
				let empty_div = "<span class='check-box'></span>";
				item.insertAdjacentHTML("afterend", empty_div)
		}
		)
		wrapMobileElements();
});
function wrapMobileElements() {
		const fbtLiItems = document.querySelectorAll('.cbb-frequently-bought-container.cbb-mobile-view .cbb-frequently-bought-selector-list li');
		if (!fbtLiItems)
				return;
		fbtLiItems.forEach(item => {
				const checkBox = item.querySelector('.check-box');
				if (checkBox) {
						let sibling = checkBox.nextElementSibling;
						const wrapper = document.createElement('div');
						while (sibling) {
								const nextSibling = sibling.nextElementSibling;
								wrapper.appendChild(sibling);
								sibling = nextSibling;
						}
						item.appendChild(wrapper);
				}
		}
		);
}
